export const LOCALSTORAGE_TOKEN_KEY = '@workforce-juridico:token';
export const LOCALSTORAGE_REFRESH_TOKEN_KEY = '@workforce-juridico:refresh_token';
export const LOCALSTORAGE_USUARIO_KEY = '@workforce-juridico:usuario';